var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C5.346 4 4 5.346 4 7C4 8.654 5.346 10 7 10C8.654 10 10 8.654 10 7C10 5.346 8.654 4 7 4ZM7 9C5.897 9 5 8.103 5 7C5 5.897 5.897 5 7 5C8.103 5 9 5.897 9 7C9 8.103 8.103 9 7 9Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C3.691 1 1 3.691 1 7C1 11.159 6.416 16.623 6.646 16.854C6.744 16.951 6.872 17 7 17C7.128 17 7.256 16.951 7.354 16.854C7.584 16.623 13 11.159 13 7C13 3.691 10.309 1 7 1ZM7 15.777C5.806 14.499 2 10.177 2 7C2 4.243 4.243 2 7 2C9.757 2 12 4.243 12 7C12 10.174 8.194 14.499 7 15.777Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a1479f62efbc2d02735dd33901b821c3.svg";
export { ForwardRef as ReactComponent };